export default Object.freeze({
  step1: 'PremiumPayment',
  step2: 'ClaimsAccount',
  step3: 'ReviewAndSubmit',
});
